<div class="reply">
    <div class="reply-head">
        <div class="avatar">
            <img src="assets/images/comments/user-avatar.svg" alt="Avatar">
        </div>
        <div class="username">{{reply.createdBy}}</div>
    </div>
    <div class="message" [innerHTML]="reply.message"></div>
    <div class="reactions-container">
        <div class="reactions">
            <div class="like">
                <img src="assets/images/comments/{{(isLiked) ? 'liked' : 'like'}}.svg" (click)="onLike()"
                    (keydown.enter)="onLike()" (keydown.space)="onLike()" alt="Like">
                <span class="like-count">{{reply.likeCount}}</span>
            </div>
            <div class="dislike">
                <img src="assets/images/comments/{{(isDisliked) ? 'disliked' : 'dislike'}}.svg" (click)="onDislike()"
                    (keydown.enter)="onDislike()" (keydown.space)="onDislike()" alt="dislike">
                <span class="dislike-count">{{reply.disLikeCount}}</span>
            </div>
        </div>
        <div class="time-stamp">{{reply.createdOn | dateAgo}}</div>
    </div>
</div>